import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

export function useTemplateBlocks() {
  return useQuery(
    orpc.communications.templateBlocks.list.queryOptions({ input: {} }),
  );
}

export function useCreateTemplateBlock() {
  const queryClient = useQueryClient();

  return useMutation(
    orpc.communications.templateBlocks.create.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: orpc.communications.templateBlocks.list.queryKey({
            input: {},
          }),
        });
      },
    }),
  );
}

export function useTemplateBlockVersions(templateBlockId: string) {
  return useQuery({
    ...orpc.communications.templateBlocks.listVersions.queryOptions({
      input: { templateBlockId },
    }),
    enabled: !!templateBlockId,
  });
}

export function useCreateTemplateBlockDraft() {
  const queryClient = useQueryClient();

  return useMutation(
    orpc.communications.templateBlocks.createDraft.mutationOptions({
      onSuccess: (_data, variables) => {
        queryClient.invalidateQueries({
          queryKey: orpc.communications.templateBlocks.listVersions.key({
            input: { templateBlockId: variables.templateBlockId },
          }),
        });
      },
    }),
  );
}

export function useUpdateTemplateBlockDraft() {
  const queryClient = useQueryClient();

  return useMutation(
    orpc.communications.templateBlocks.updateDraft.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: orpc.communications.templateBlocks.listVersions.key(),
        });
      },
    }),
  );
}

export function usePublishTemplateBlock() {
  const queryClient = useQueryClient();

  return useMutation(
    orpc.communications.templateBlocks.publish.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: orpc.communications.templateBlocks.list.queryKey({
            input: {},
          }),
        });
        queryClient.invalidateQueries({
          queryKey: orpc.communications.templateBlocks.listVersions.key(),
        });
      },
    }),
  );
}

export function useDeleteTemplateBlockDraft() {
  const queryClient = useQueryClient();

  return useMutation(
    orpc.communications.templateBlocks.deleteDraft.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: orpc.communications.templateBlocks.listVersions.key(),
        });
      },
    }),
  );
}

export function useRenderTemplateBlockPreview() {
  return useMutation(
    orpc.communications.templateBlocks.renderPreview.mutationOptions(),
  );
}
